import React from 'react'
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import { Link } from '@mui/material';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { resolveLangFromPath } from '../../_i18n/IntlProviderConfigured';

const ResponsiveAppBar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const intl = useIntl();
  const location = useLocation();

  const pathname = (location && location.pathname) || '';
  const lang = resolveLangFromPath(pathname);
  const currentLang = lang === 'en' ? '' : lang;

  const timerHref = currentLang ? `/${currentLang}` : '/';
  const focusHref = currentLang ? `/focus/${currentLang}` : '/focus';
  const stopwatchHref = currentLang ? `/stopwatch/${currentLang}` : '/stopwatch';
  const blogHref = '/blog';

  const pages = [
    {
      title: intl.formatMessage({ id: 'header.focus', defaultMessage: 'Focus Timer' }),
      href: focusHref
    },
    {
      title: intl.formatMessage({ id: 'header.stopwatch', defaultMessage: 'Stopwatch' }),
      href: stopwatchHref
    },
    {
      title: intl.formatMessage({ id: 'header.timer', defaultMessage: 'Timer' }),
      href: timerHref
    },
    {
      title: intl.formatMessage({ id: 'header.blog', defaultMessage: 'Blog' }),
      href: blogHref
    }
  ];

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };


  return (
    <AppBar
      position="static"
      color="default"
      elevation={0}
      sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box
            component="img"
            sx={{
              display: { xs: "none", md: "flex" },
              mr: 1
            }}
            alt="online-timer.me"
            src="/logo32.png"
          />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href={timerHref}
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "inherit",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none"
            }}
          >
            Online-Timer
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left"
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left"
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" }
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page.title}
                  component='a'
                  href={page.href}
                  onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">{page.title}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          {/* <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} /> */}
          <Box
            component="img"
            sx={{
              display: { xs: "flex", md: "none" },
              mr: 1
            }}
            alt="online-timer.me"
            src="/logo32.png"
          />
          <Typography
            variant="h5"
            noWrap
            component="a"
            rel="nofollow sponsored"
            href={timerHref}
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "inherit",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none"
            }}
          >
            Online-Timer
          </Typography>
          <Box
            sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
            justifyContent="right "
          >
            {pages.map((page) => (
              <Link
                key={page.title}
                href={page.href}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: "inherit", display: "block", marginLeft: "10px" }}
              >
                {page.title}
              </Link>
            ))}
          </Box>
        </Toolbar>
      </Container>


    </AppBar>

  )

}

export default ResponsiveAppBar
